import { render } from "./GlobalHome.vue?vue&type=template&id=2e5d0b0a&scoped=true"
import script from "./GlobalHome.vue?vue&type=script&lang=js"
export * from "./GlobalHome.vue?vue&type=script&lang=js"

import "./GlobalHome.vue?vue&type=style&index=0&id=2e5d0b0a&scoped=true&lang=css"

import exportComponent from "/Users/vincentblin/Sites/ONET-WA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5d0b0a"]])

export default __exports__